/*****************************************************************************************
 * 설명 : 관리자 > 시스템관리 > 권한그룹 관리 > 추가/수정
 * URI : /admin/system/auth/group
*****************************************************************************************/
import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import * as Yup from "yup";

import { MESSAGE_DELAY } from 'config/config';

import { InputEx, ToggleButtonGroupEx } from 'components/inputEx';
import alertMsg from 'components/message';

import {Restful} from 'service/restful';
import { PaperComponent } from 'service/utils';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
export const AuthGroupModal = ( props ) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [getApi] = Restful();

  const [title, setTitle] = useState('추가');

  const formik = useFormik({
    initialValues: {
      seq: 0,
      groupName: '',
      memberLevel: 0,
      isUse: '1'
    },
    validationSchema: Yup.object().shape({
      groupName: Yup.string().max(30, "30자리").required('필수'),
      memberLevel: Yup.number().typeError('숫자').required('필수')
    }),
    onSubmit: (values) => {

      let params = {
        program: 'admin',
        service: 'system',
        version: '1.0',
        action: 'setAuthGroup',
        ...values
      }

      getApi("post", params).then( response => {
        if( response !== undefined && response.data.result ) {
          alertMsg(response.data.message, "S", MESSAGE_DELAY);

          if( props.getList ) props.getList();

          props.close();

        } else {
          alertMsg(response.data.message, "E", MESSAGE_DELAY);
        }
      });
    }
  });

  /***************************************************************************************
   * 설명 : 모달 오픈 시 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.open ) {
      if( props.data.seq !== undefined ) {
        formik.setValues(props.data);

        setTitle('수정');
      } else {
        setTitle('추가');
      }
    }

    // eslint-disable-next-line
  }, [props.open]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <Dialog
      open={props.open}
      onClose={() => (event, reason) => {
        if(reason && reason === "backdropClick") return;
        props.close();
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "500px",  // Set your width here
          },
        },
      }}
    >
      <section className="modal">
        <section className="modal-wrap" style={{ width: '500px' }}>
          <form onSubmit={formik.handleSubmit}>
            <header className="modal-header" style={{ cursor: 'move' }} id="draggable-dialog-title">
              <div className="modal-title">권한그룹 {title}</div>
              <Button className="close-btn" onClick={props.close}>
                <CloseIcon style={{ color: '#fff', fontSize: '28px' }}></CloseIcon>
              </Button>
            </header>

            <section className="modal-body">
              <table className="input-table">
                <colgroup>
                  <col style={{width: '25%'}} />
                  <col style={{width: '75%'}} />
                </colgroup>

                <tbody>
                  <tr>
                    <th scope="row"><label htmlFor="groupName">권한그룹명</label></th>
                    <td>
                      <InputEx
                        name="groupName"
                        formik={formik}
                        fullWidth={true}
                        focus={true}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row"><label htmlFor="memberLevel">레벨</label></th>
                    <td>
                      <InputEx
                        name="memberLevel"
                        formik={formik}
                        fullWidth={true}
                        label="0~99"
                      />
                      <div className="mt10 mb10">
                        ※ 0 = 비회원, 1 = 일반회원, 80이상 직원, 90이상 관리자
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row"><label htmlFor="isUse">사용여부</label></th>
                    <td>
                      <ToggleButtonGroupEx
                        name="isUse"
                        exclusive={true}
                        formik={formik}
                        data={[
                          {label: '사용', value: '1'},
                          {label: '사용안함', value: '0'},
                        ]}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>

            <footer className="modal-footer">
              <div className="modal-footer-center">
                <Button
                  color="inherit"
                  variant="outlined"
                  className="Btn"
                  onClick={() => {
                    props.close();
                  }}
                >창닫기</Button>

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="Btn ml10"
                >저장하기</Button>
              </div>
            </footer>
          </form>
        </section>
      </section>
    </Dialog>
  )
}

export default AuthGroupModal;